import React, {memo, useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";
import {Head, Loading} from "../../../components";
import Api from "../../../utils/api";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

import {Paper} from "@mui/material";
import SelectProduct from "../../../components/selectProducts/selectProduct";
import {useParams} from "react-router-dom";

const ItemProductCreate = memo((props) => {

    const productReducer = useSelector((state) => state.productReducer)

    
    const { id } = useParams();
    

    const initStat = {
        status: 1,
        title: '',
        link: '',
        products: [],
        form: "item_product_update",
        order: null,
    }

    const [form, setForm] = useState(initStat);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState(false);
    const [relatedItem, setRelatedItem] = useState([]);

    useEffect(() => {
        getData()
    } ,[])

    const getData = () => {
        setLoading(true)

        let object = {
            form:"item_product_admin",
            type:null,
            sort_type:null
        }

        new Api().get('/products/itemProduct/'+ id , object).then((response) => {
            setLoading(false)
            let init_products = [];
            response.products && response.products.map((t) => {
                init_products.push(t.id);
            });
            setRelatedItem(init_products)

            setProducts(init_products);

            setForm(response);
        })
    }


    const handleRequest = (event) => {
        event.preventDefault();
        let arr = []
        for(let i in form.products) {
            arr.push(form.products[i].id)
        }

        setLoading(true)
        new Api().put('/products/itemProduct/' + id , { ...initStat ,...form , products:arr },false).then((response) => {
            if (response.status) {

                setForm(response.details);

                toast.success(response.msg);

            } else {

                toast.error(response.msg);
            }
            setLoading(false)

        }).catch(() => {
            setLoading(false)

        })
    }


    const handleChangeElement = (event) => {

        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };



    return(
        <Container>
            <div className={'chat-loading'}>
                {loading && <Loading />}
            </div>
            <Head data={{ 'link': '/product/item', 'title': 'ویرایش'}} />
            <Box mt={5}>
                <form onSubmit={handleRequest}>
                    <Box mt={5}>
                        <Paper style={{ padding: '25px'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="عنوان"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.title}
                                        fullWidth
                                        name='title'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        select
                                        label="وضعیت"
                                        value={form.status}
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='status'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    >
                                        <MenuItem value={1}>فعال</MenuItem>
                                        <MenuItem value={0}>غیرفعال</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        style={{ textAlign: 'left', direction: 'ltr'}}
                                        label="لینک"
                                        value={form.link}
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='link'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ position: "relative"}}>
                                        <SelectProduct title={"محصولات "}  type ={"product"}  state={"products"} list = {productReducer} formData={form} onchange={(items) => form.products = items.products} />
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                    <Box mt={5}>
                        <Button disabled={loading} variant='contained' color='primary' type="submit">ایجاد اطلاعات</Button>
                    </Box>
                </form>
            </Box>
        </Container>
    );
})



export default ItemProductCreate;